import React from 'react';
import { SvgIcon } from '@mui/material';
import styles from './iconStyles';

function NotificationIcon() {
  return (
    <SvgIcon style={styles.icon}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M10 19V19.5C10 20.8807 10.8954 21.5 12 21.5C13.1046 21.5 14 20.8807 14 19.5V19H10Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M18.8543 17.5259C18.7549 16.5198 18.6752 14.9007 18.6752 13.8876V10.114C18.6752 6.18462 15.6871 3 12 3C8.31217 3 5.32476 6.1826 5.32476 10.114V13.8876C5.32476 14.9 5.24488 16.5218 5.14566 17.5259L5 19H19L18.8543 17.5259Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
}

export default NotificationIcon;